import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Dialog, DialogActions, DialogContent, Button } from '@mui/material';

export default function Modal ({ className, buttonLabel, children }) {
	const [isOpen, setIsOpen] = useState(false)
	const { t } = useSelector(redux => redux.store)

	return (
		<div>
			<div className={className}>
				<Button size="small" onClick={() => setIsOpen(!isOpen)}>
					{buttonLabel}
				</Button>
			</div>
			<Dialog
				open={isOpen}
				onClose={() => setIsOpen(false)}
				aria-labelledby="legend-scores"
				aria-describedby="legend-scores-afbeelding"
			>
				<DialogActions>
					<Button onClick={() => setIsOpen(false)}>
						{t.close}
					</Button>
				</DialogActions>
				<DialogContent>
					{children}
				</DialogContent>
			</Dialog>
		</div>
	)
}
